const ShieldIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6_196)">
    <path d="M17 10C13.14 10 10 13.141 10 17C10 20.859 13.14 24 17 24C20.86 24 24 20.859 24 17C24 13.141 20.86 10 17 10ZM17 22C14.243 22 12 19.757 12 17C12 14.243 14.243 12 17 12C19.757 12 22 14.243 22 17C22 19.757 19.757 22 17 22ZM16 16V14C16 13.447 16.448 13 17 13C17.552 13 18 13.447 18 14V16C18 16.553 17.552 17 17 17C16.448 17 16 16.553 16 16ZM18.5 19.5C18.5 20.328 17.828 21 17 21C16.172 21 15.5 20.328 15.5 19.5C15.5 18.672 16.172 18 17 18C17.828 18 18.5 18.672 18.5 19.5ZM10.395 23.447C10.22 23.798 9.867 24 9.499 24C9.349 24 9.196 23.966 9.053 23.895C7.541 23.139 0 19.023 0 12.194V6.873C0 4.713 1.377 2.806 3.426 2.126L9.685 0.051C9.89 -0.017 10.11 -0.017 10.315 0.051L16.574 2.126C18.623 2.806 20 4.713 20 6.872V7C20 7.553 19.552 8 19 8C18.448 8 18 7.553 18 7V6.872C18 5.577 17.174 4.433 15.944 4.024L10 2.053L4.056 4.024C2.826 4.432 2 5.577 2 6.872V12.193C2 17.845 8.62 21.442 9.947 22.105C10.441 22.352 10.641 22.953 10.394 23.447H10.395Z" fill="#01486D"/>
    </g>
    <defs>
    <clipPath id="clip0_6_196">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  );
};

export default ShieldIcon;
